<template>
	<div>
		<h3 style="display: flex;margin-left: -10px;margin-top: -15px;">
			<div class="blue"></div>裂变活动列表
		</h3>
		<div>
			<el-form label-width="100px" label-position="left">
				<h4>基本设置</h4>
				<el-form-item label="活动名称">
					<el-input v-model="sendData.name" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="参与人数限制">
					<el-input-number v-model="sendData.limitNum" :min="1" :max="9999999" size="small"></el-input-number>
				</el-form-item>
				<el-form-item label="结束时间">
					<el-date-picker type="date" v-model="sendData.time" value-format="yyyy-mm-dd"></el-date-picker>
				</el-form-item>
				<h4>奖励设置</h4>
				<el-form-item label="邀请人奖励">
					<div class="flex">
						<div v-if="sendData.inviterCouponId!=''">
							<el-tag v-if="sendData.inviterCoupon==0">券id：{{sendData.inviterCouponId}}</el-tag>
							<el-tag v-else>券包id：{{sendData.inviterCouponId}}</el-tag>
						</div>
						<el-button type="text" size="small" @click="inviter=true" class="abutton">
							<i class="el-icon-plus"></i>
						</el-button>
					</div>
				</el-form-item>
				<el-form-item label="受邀人奖励">
					<div class="flex">
						<div v-if="sendData.shareCouponId!=''">
							<el-tag v-if="sendData.shareCoupon==0">券id：{{sendData.shareCouponId}}</el-tag>
							<el-tag v-else>券包id：{{sendData.shareCouponId}}</el-tag>
						</div>
						<el-button type="text" size="small" @click="share=true" class="abutton">
							<i class="el-icon-plus"></i>
						</el-button>
					</div>
				</el-form-item>
				<el-form-item label="状态">
					<el-switch v-model="sendData.hidden" :active-value="false" active-text="上架" :inactive-value="true"
						inactive-text="下架"></el-switch>
				</el-form-item>
				<h4>内容设置</h4>
				<el-form-item label="详情页上传">
					<div>
						<upload v-model="sendData.img"  class="el-tabs-pane-upload"  ref="sss"
							style="width: 300px; height: 700px;" />
						<p style="font-size: 14px;color: #808080;">点击上传详情页图片</p>
					</div>
				</el-form-item>
			</el-form>
			<div class="flex" style="padding-left: 150px;">
				<el-button @click="back()">取消</el-button>
				<el-button type="primary" @click="save()">保存</el-button>
			</div>
		</div>
		<el-dialog :visible.sync="inviter">
			<div class="title">
				<div v-if="sendData.inviterCoupon==0" class="stitle">选择券</div>
				<div v-else class="stitle">选择券包</div>
			</div>
			<el-radio-group v-model="sendData.inviterCoupon" @change="cleanId(0)"
				style="margin-top: 15px;margin-bottom: 15px;">
				<el-radio :label="0">券</el-radio>
				<el-radio :label="1">券包</el-radio>
			</el-radio-group>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="sendData.inviterCoupon==0?couponList:couponPackageList" tooltip-effect="dark"
					style="width: 100%">
					<el-table-column label="券包ID">
						<template scope="scope">
							<el-radio :label="scope.row.id" v-model="sendData.inviterCouponId"></el-radio>
						</template>
					</el-table-column>
					<el-table-column v-if="sendData.inviterCoupon==0" prop="title" align="center" label="名称">
					</el-table-column>
					<el-table-column v-else prop="name" align="center" label="名称"></el-table-column>
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChange02" @current-change="handleCurrentChange02"
						:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper"
						:total="sendData.inviterCoupon==0?query.coupontotal:query.couponPackageTotal">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="share">
			<div class="title">
				<div v-if="sendData.shareCoupon==0" class="stitle">选择券</div>
				<div v-else class="stitle">选择券包</div>
			</div>
			<el-radio-group v-model="sendData.shareCoupon" @change="cleanId(1)"
				style="margin-top: 15px;margin-bottom: 15px;">
				<el-radio :label="0">券</el-radio>
				<el-radio :label="1">券包</el-radio>
			</el-radio-group>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="sendData.shareCoupon==0?couponList:couponPackageList" tooltip-effect="dark"
					style="width: 100%">
					<el-table-column label="券包ID">
						<template scope="scope">
							<el-radio :label="scope.row.id" v-model="sendData.shareCouponId"></el-radio>
						</template>
					</el-table-column>
					<el-table-column v-if="sendData.shareCoupon==0" prop="title" align="center" label="名称">
					</el-table-column>
					<el-table-column v-else prop="name" align="center" label="名称"></el-table-column>
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChange02" @current-change="handleCurrentChange02"
						:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper"
						:total="sendData.shareCoupon==0?query.coupontotal:query.couponPackageTotal">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";

	export default {
		components: {
			upload
		},
		data() {
			return {
				inviter: false,
				share: false,
				sendData: {
					name: '',
					limitNum: '',
					inviterCoupon: 0,
					inviterCouponId: '',
					shareCoupon: 0,
					shareCouponId: '',
					img: '',
					time: '',
					hidden: '',
				},
				couponList: [],
				couponPackageList: [],
				query: {
					pageNum: 1,
					pageSize: 20,
					coupontotal: 0,
					couponPackageTotal: 0
				}
			}
		},
		mounted() {
			this.getCoupon()
			this.sendData.time = new Date
			if (this.$route.query.id != null) {
				this.getDetail()
			}
		},
		methods: {
			getDetail() {
				this.$http.get("dMarketingShare/list" + "?id=" + this.$route.query.id + "&pageNum=" + this.query.pageNum +
					"&pageSize=" + this.query.pageSize).then(res => {
					this.sendData = res.body.data[0]
				})
			},
			getCoupon() {
				this.$http.get("dCoupon/list" + "?pageNum=" + this.query.pageNum + "&pageSize=" + this.query.pageSize)
					.then(res => {
						this.couponList = res.body.data;
						this.query.coupontotal = res.body.total;
					})
				this.$http.post("couponPackage/findDCouponPackage", JSON.stringify(this.query)).then(res => {
					this.couponPackageList = res.body.data;
					this.query.couponPackageTotal = res.body.total;
				})
			},
			save() {
				this.$http.post("dMarketingShare/save", JSON.stringify(this.sendData)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.$router.push("marketingShare")
					}
				})
			},
			cleanId(id) {
				if (id == 0) {
					this.sendData.inviterCouponId = ''
				} else {
					this.sendData.shareCouponId = ''
				}
			},
			handleSizeChange02(val) {
				this.query.pageSize = val;
				this.getCoupon();
			},
			handleCurrentChange02(val) {
				this.query.pageNum = val;
				this.getCoupon();
			},
			back() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style>
	.flex {
		display: flex;
	}

	.blue {
		width: 5px;
		height: 15px;
		background: #409EFF;
		border-radius: 2px;
		margin-right: 8px;
		position: relative;
		top: 4px;
	}

	.abutton {
		color: #999;
		border: 2px dashed;
		width: 50px;
		margin-left: 10px;
	}

	.title {
		margin-top: -10px;
	}

	.stitle {
		flex: 1;
		font-size: 18px;
	}
</style>